import ApiEndpoint from '../constants/ApiEndpoint.esm.js';
import Environment from '../constants/Environment.esm.js';
import { getEnvironment } from './getEnvironment.esm.js';

var _ENDPOINT_BY_ENVIRONM;
var ENDPOINT_BY_ENVIRONMENT = (_ENDPOINT_BY_ENVIRONM = {}, _ENDPOINT_BY_ENVIRONM[Environment.DEVELOPMENT] = ApiEndpoint.SANDBOX, _ENDPOINT_BY_ENVIRONM[Environment.STAGING] = ApiEndpoint.STAGING, _ENDPOINT_BY_ENVIRONM[Environment.SANDBOX] = ApiEndpoint.SANDBOX, _ENDPOINT_BY_ENVIRONM[Environment.PRODUCTION] = ApiEndpoint.PRODUCTION, _ENDPOINT_BY_ENVIRONM);
var getApiEndpoint = function getApiEndpoint() {
  var environment = getEnvironment(window);
  return ENDPOINT_BY_ENVIRONMENT[environment];
};

export { getApiEndpoint };
//# sourceMappingURL=getApiEndpoint.esm.js.map
